import { useNavigate } from 'react-router-dom';
import { 
    Trash2, 
    Calendar,
    ArrowRight,
    ClipboardCheck
} from 'lucide-react';

type ConditioningTestSessionEntryProps = {
    session: any;
    testTitle: string;
    remove: (id: string) => void;
};

const ConditioningTestSessionEntry: React.FC<ConditioningTestSessionEntryProps> = ({ session, testTitle, remove }) => {
    const navigate = useNavigate();

    const handleParentClick = () => {
        navigate("/conditioning/test-session", { state: { session }});
    };

    const handleDeleteClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        remove(session.id);
    };

    return (
        <div 
            className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden transition-all duration-300 hover:shadow-xl mb-4 cursor-pointer group"
            onClick={handleParentClick}
        >
            {/* Header */}
            <div className="bg-gradient-to-r from-indigo-500 to-indigo-600 p-4 text-white relative">
                <div className="absolute inset-0 bg-white opacity-10"></div>
                <div className="relative flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                        <ClipboardCheck className="w-4 h-4" />
                        <div>
                            <h3 className="font-bold text-lg">
                                {testTitle.length > 55 ? testTitle.slice(0, 55) + '...' : testTitle}
                            </h3>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex items-center space-x-2">
                        <button
                            onClick={handleDeleteClick}
                            className="w-8 h-8 bg-red-500 bg-opacity-80 hover:bg-opacity-100 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
                            title="Delete"
                        >
                            <Trash2 className="w-4 h-4 text-white" />
                        </button>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="p-6">

                {/* Test Date */}
                <div className="space-y-4">
                    <div className="bg-blue-50 rounded-lg p-4 flex items-center space-x-3">
                        <Calendar className="w-5 h-5 text-blue-500" />
                        <div>
                            <div className="text-sm text-blue-600 font-medium">Test Date</div>
                            <div className="text-lg font-bold text-blue-800">
                                {new Date(session.test_date).toLocaleDateString('en-GB')}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Click indicator */}
                <div className="flex items-center justify-center mt-4 pt-4 border-t border-gray-100 text-gray-500 group-hover:text-gray-700 transition-colors duration-200">
                    <span className="text-sm font-medium mr-2">View Test Results</span>
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
                </div>
            </div>
        </div>
    );
};

export default ConditioningTestSessionEntry;